<template>
<div id="app" ref="app">
  <router-view v-if="isRouterAlive"></router-view>
  <audio ref="audio" hidden="true" src="./assets/img/bigScreen/alarm.mp3"></audio>
  <!-- <WebSocket v-if="$route.path !== '/login'" @dataCallback="socketBack" />
  <div class="warnList" v-if="!canAlarmPop&&showMess">
    <div class="imgBox" @click="closeWarn"><img src="./assets/img/close.png" alt=""></div>
    <fieldset>
      <legend>报警通知</legend>
      <el-scrollbar>
        <ul class="infinite-lists">
          <li :class="{red:i===index}" v-for="(item,index) in dataList" :key="index" class="list-item" @click="jumpMap(item,index)">{{(index+1)+'、'+ item.content }}</li>
        </ul>
      </el-scrollbar>
    </fieldset>
  </div> -->
</div>
</template>

<script>
import bus from '@/bus/bus';
// import WebSocket from "@/components/common/WebSocket"
export default {
  components: {
    // WebSocket
  },
  name: 'app',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true,
      canAlarm: true,
      canAlarmPop: true,
      alarms: [],
      alarmDatas: [],
      speecher: null,
      dataList: [],
      showMess: false,
      i: null,
      audioDemo: null
    }
  },
  mounted() {

    // let lang = localStorage.getItem('lang') || 'zh-CN'
    // 多语言翻译
    this.__patch__(this.$refs.app)
    this.$nextTick(() => {
      this.audioDemo = this.$refs.audio
      this.watchScreen()
    })
    bus.$on('changeSysname', e => {
      if (this.$route.path !== '/login') {
        this.query()
      }
    });
  },
  watch: {
    $route: {
      handler(val, oldval) {
        // console.log(val); //新路由信息
        // console.log(oldval); //老路由信息
        if (val.path == '/homePage' || val.path == '/screen'||val.path == '/login') {
          this.canAlarmPop = false
          this.$notify.closeAll()
          if(val.path !== '/screen'&&val.path!=="/homePage"){
            console.log(55555)
            this.dataList=[]   
            this.showMess=false   
          }else if(oldval.path!=='/screen'&&oldval.path!=="/homePage"){
            this.dataList=[]   
            this.showMess=false
          }                       
        } else {
          this.canAlarmPop = true
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  created() {
    if (this.$route.path !== '/login') {
      // 20分钟请求一次，防止session过期
      this.getSession()
      this.timmer = setInterval(() => {
        this.getSession()
      }, 1200 * 1000)
      
      this.query()
      if (this.$route.path == '/homePage'||this.$route.path == '/screen') {
        this.canAlarmPop = false
        this.$notify.closeAll()
        this.dataList=[]      
        this.showMess=false        
      } else {
        this.canAlarmPop = true
      }
    }
  },
  methods: {
    getSession () {
      this.request.post('/front/api/session/rolsession')
    },
    closeWarn(){
      this.showMess = false
    },
    jumpMap(data,index){
      this.i=index
      this.$store.dispatch('mapDataChange', data)
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    watchScreen() {
      window.onresize = () => {
        this.$store.dispatch('screenChange', new Date())
      }
    },
    load() {
      // this.dataList.push({})
    },
    broadcast(test) {
      console.log(test);
      // console.log(new SpeechSynthesisUtterance());

      var msg = new SpeechSynthesisUtterance(test)

      // msg.text = test;
      msg.lang = 'zh-CN';
      // msg.volume = 50 // 声音的音量
      msg.rate = 1 // 语速，数值，默认值是1，范围是0.1到10
      // msg.pitch = 1.5 // 表示说话的音高，数值，范围从0（最小）到2（最大）。默认值为1
      // msg.rate = 1 //播放语速    
      //msg.pitch = 10 音调高低
      // msg.text = "播放文本"
      // msg.volume = 1 //播放音量
      // console.log(msg);      
      speechSynthesis.speak(msg)
    },
    socketBack(data) {
      // console.log(333);
      this.$store.dispatch('alarmData', data)
      let dataObj = JSON.parse(data)
      // console.log(dataObj)
      if (dataObj.type == 'New') {
        this.showMess=false
      } else {
        this.dataList.unshift(dataObj.data)
        this.showMess=true
      }
        // console.log(this.alarms);
        if (this.alarms.length >=5) {
          this.alarms[0].close()
        }
        if (this.canAlarmPop&&this.showMess) {
          let notify = this.$notify({
            title: "报警通知",
            message: dataObj.data.content,
            type: "error",
            duration: 60000 * 5,
            position: "bottom-right",
            onClick: () => {
              // this.$refs.audio.pause()
              // this.$router.push('/alarmManament?id=' + data.alarmId)
              this.$router.push('alarmHistory')
            },
            onClose: () => {
              console.log(dataObj.data.alarmId);
              this.alarmDatas.forEach((val, i) => {
                if (val.alarmId === dataObj.data.alarmId) {
                  this.alarms.splice(i, 1)
                  this.alarmDatas.splice(i, 1)
                }
              })
              // this.$refs.audio.pause()
            }
          })
          // console.log(this.alarms);
          if (this.alarms.length >=5) {
            this.alarms.push(notify)
            this.alarmDatas.push(dataObj.data)
            this.alarms.shift()
          } else {
            this.alarms.push(notify)
            this.alarmDatas.push(dataObj.data)
          }
          // console.log(this.alarms);
        }
        if (this.canAlarm&&dataObj.type !== 'New') {
          console.log(this.myBrowser());
          if(this.myBrowser()=="Chrome"){
            this.speaking(dataObj.data.content)            
          }else{
            this.broadcast(dataObj.data.content)
          }
          // this.$refs.audio.play()
        }
    },
    speaking(params) {
      this.speecher = window.speechSynthesis
      // console.log(this.speecher);
      if (this.speecher.speaking) {
        // console.error('speechSynthesis.speaking');
        this.speecher.cancel()
      }
      const voices = this.speecher.getVoices()
      // console.log(voices);
      let utterThis = new SpeechSynthesisUtterance(params)
      utterThis.onend = function (event) {
        // console.log('SpeechSynthesisUtterance.onend');
      }
      utterThis.onerror = function (event) {
        // console.error('SpeechSynthesisUtterance.onerror');
      }
      utterThis.rate = '1.2'
      for (let i = 0; i < voices.length; i++) {
        if (voices[i].name === 'Microsoft Huihui - Chinese (Simplified, PRC)') {
          utterThis.voice = voices[i];
          break;
        }
      }
      this.speecher.speak(utterThis)
    },
    query(params) {
      this.request.get("/front/system/config/query").then(rs => {
        // console.log(rs);
        if (rs.code == 200) {
          let data = rs.data;
          this.loading = false;
          this.setting = [];
          for (let i = 0; i < data.length; ++i) {
            let item = data[i];
            if (item.type === 2) {
              if (item.value == "0") {
                //打开声音
                // this.speaking(params)
                this.canAlarm = true
              } else {
                //关闭声音
                this.canAlarm = false
                window.speechSynthesis.cancel()
              }
            }
          }
        }
      });
    },
    myBrowser() {
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
      var isIE = userAgent.indexOf("compatible") > -1
              && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
      var isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
      var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
      var isSafari = userAgent.indexOf("Safari") > -1
              && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
      var isChrome = userAgent.indexOf("Chrome") > -1
              && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器

      if (isIE) {
          var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
          reIE.test(userAgent);
          var fIEVersion = parseFloat(RegExp["$1"]);
          if (fIEVersion == 7) {
              return "IE7";
          } else if (fIEVersion == 8) {
              return "IE8";
          } else if (fIEVersion == 9) {
              return "IE9";
          } else if (fIEVersion == 10) {
              return "IE10";
          } else if (fIEVersion == 11) {
              return "IE11";
          } else {
              return "0";
          }//IE版本过低
          return "IE";
      }
      if (isOpera) {
          return "Opera";
      }
      if (isEdge) {
          return "Edge";
      }
      if (isFF) {
          return "FF";
      }
      if (isSafari) {
          return "Safari";
      }
      if (isChrome) {
          return "Chrome";
      }
    }
  }
}
</script>

<style lang="scss">
@import url('./assets/css/common.css');
@import url("./assets/css/fontFamily.css");

html,
body {
  width: 100%;
  min-width: 1200px;
  height: 100%;
}

body {
  background: #fff;
  color: #222;
  overflow: hidden;
}
// ===el-table兼容safari浏览器
body .el-table th.gutter {
  display: table-cell !important;
}

body .el-table colgroup.gutter {
  display: table-cell !important;
}

table {
  width: 100% !important;
}
// ===

.v-modal {
  z-index: 100 !important;
}

#app {
  height: 100%;
  // font-family: PingFangZhun;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;

  .warnList {
    position: absolute;
    bottom: 0;
    right: 22%;
    transform: translateY(-28%);
    color: #fff;
    font-size: 16px;
    width: 350px;
    height: 225px;
    box-sizing: border-box;
    .imgBox{
      cursor: pointer;
      position: absolute;
      top: 15px;
      right:2px;
      width: 24px;
      height: 24px;
      img{
        width: 100%;
      }
    }
    .el-scrollbar__wrap {
      overflow-x: unset;
      background: rgba(29, 55, 82, 0.85);
    }

    fieldset {
      height: 100%;
      width: 100%;
      border: 2px solid #1890ff;
      border-radius: 10px;
      box-sizing: border-box;

      legend {
        font-size: 20px;
        color: #fff;
        text-shadow: 0 0 0 var(--monitorBorder, #3beff0), 0 0 4px var(--monitorBorder, #3beff0), 0 0 0 var(--monitorBorder, #3beff0), 0 0 4px var(--monitorBorder, #3beff0);
      }
    }
    .list-item{
      cursor: pointer;
      &.red{
        color: #DD3071;
      }
    }
  }
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

/* elementui滚动条样式 */
.scrollbar-wrapper {
  overflow-x: hidden !important;
}

.el-scrollbar__bar.is-vertical {
  right: 0px;
}

.el-scrollbar {
  height: 100%;
}

.el-scrollbar__view {
  min-height: 100%;
}

.el-scrollbar {
  &>.el-scrollbar__bar {
    opacity: 1 !important;
  }
}
  //菜单省略号
.el-menu-item, .el-submenu__title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 图片盒子 */
.imgBox {
  font-size: 0;
  line-height: 0;

  img {
    width: 100%;
    height: 100%;
  }
}

a {
  color: #2177E6;
}

//确认颜色样式
.primaryBtn {
  background: #2177E6;
  color: #fff;
  padding: 0 15px;
  height: 36px;
  line-height: 36px;
  border: none;
  font-size: 14px;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  margin-right: 10px;

  &:hover {
    background: rgb(7, 93, 197);
  }
}

.primaryBtnClose {
  box-sizing: border-box;
  margin-left: 10px;
  background: #fff;
  color: #7F7F7F;
  padding: 0 15px;
  height: 28px;
  line-height: 28px;
  border: none;
  font-size: 12px;
  border-radius: 4px;
  box-shadow: 0 0 1px 1px #DCDFE6;
  outline: none;
  cursor: pointer;

  &:hover {
    color: #fff;
    background: #D5D5D5;
  }
}

//进度条样式 
.el-progress {
  .el-progress-bar {
    .el-progress-bar__outer {
      border-radius: 0;
      background: #d9d9d9;

      .el-progress-bar__inner {
        border-radius: 0;
      }
    }
  }
}

/* input框样式 */
.el-input {
  .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
}

/* 日历 */
.query .el-date-editor--datetimerange.el-input,
.query .el-date-editor--datetimerange.el-input__inner {
  width: 360px;
}

.el-range-editor.el-input__inner {
  height: 32px;
  line-height: 32px;
}

.query .el-date-editor .el-range__icon,
.query .el-select .el-input .el-select__caret {
  line-height: 25px !important;
}

.query .el-date-editor .el-range-separator {
  line-height: 24px !important;
}

.query .el-input__prefix .el-icon-search {
  line-height: 32px !important;
}

.query .el-date-editor .el-range__close-icon {
  line-height: 26px !important;
}

//form表单提交
.el-form {
  .el-form-item {
    //  margin-bottom: 8px;
    margin-bottom: 20px;
  }
}

.el-dialog,
.el-dialog--center {
  .el-dialog__body {
    padding: 10px 25px 20px !important;

    .el-form-item__label {
      font-size: 13px;
    }
  }
}

//单选按钮样式
.el-radio {
  &.is-checked {
    .el-radio__input {
      &.is-checked {
        .el-radio__inner {
          border-color: #2177E6;
          background: #2177E6;
        }
      }
    }

    .el-radio__label {
      color: #2177E6 !important;
    }
  }
}

//下拉框样式
.el-select-dropdown {
  .el-select-dropdown__wrap {
    .selected {
      color: #2177E6;
    }
  }
}

//input输入框focus样式
.el-input {
  &.is-focus {
    .el-input__inner {
      border-color: #2177E6 !important;
    }
  }

  .el-input__inner {
    &:focus {
      border-color: #2177E6 !important;
    }
  }
}

// 表格滚动条的宽度
.el-table__body-wrapper::-webkit-scrollbar {
  width: 6px; // 横向滚动条
  height: 6px; // 纵向滚动条 必写
}

// 表格滚动条的滑块
.el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}

//抽屉样式
.el-drawer__wrapper {
  left: 220px !important;
  top: 100px !important;
  outline: none;

  .el-drawer__container {
    outline: none;

    //  top: 100px;
    .el-drawer {
      outline: none;

      .el-drawer__header {
        outline: none;
        position: absolute;
        box-sizing: border-box;
        width: 100%;
        background: #1E2639;
        padding: 10px 20px;
        margin-bottom: 0;

        &>span {
          color: #fff;
          outline: none;
        }

        .el-drawer__close-btn {
          outline: none;

          .el-icon-close {
            color: #fff;
          }

          //   display: none;
        }
      }

      .el-drawer__body {
        outline: none;
        box-sizing: border-box;
        padding-top: 45px;
        height: 100%;
      }
    }
  }
}

//抽屉内样式
.drawerWrap {
  outline: none;
  height: 100%;
  padding-bottom: 60px;
  position: relative;

  .drawerBody {
    height: 100%;
    padding: 0 35px;
    overflow: auto;

    .el-form-item__label {
      color: #000;
    }
  }

  .drawerFoot {
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    text-align: center;
    height: 60px;
    line-height: 60px;
    box-shadow: 4px 0 4px 2px rgba(155, 155, 155, 0.1);
  }
}

// 信息提示框
.zZindex {
  z-index: 5000 !important;
}

// 菜单提示框
.el-menu--vertical {
  background: #33383E;
  left: 78px !important;
  border-radius: 5px;

  .el-menu--popup-right-start {
    color: #fff;
    background: rgba(48, 49, 51, 1);

    .el-menu-item {
      .item_title {
        color: #fff;
      }

      &:hover {
        color: #1089FF;
      }
    }
  }
}

//下拉框展示
.el-select-dropdown {
  min-width: 270px !important;
}
//滚动条样式
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
</style>
